import { steps } from '../../data/landingPage';
import PhoneMockup from '../PhoneMockup/PhoneMockup';
import SectionHeading from '../SectionHeading/SectionHeading';
import './HowItWorks.css';

function HowItWorks() {
  return (
    <section className="how" id="how" aria-labelledby="how-title">
      <SectionHeading id="how-title" title="How it works" subtitle="A gentle reset in four simple steps." />
      <div className="steps">
        {steps.map((step, index) => (
          <article className="step" key={step.title}>
            <PhoneMockup src={step.mockup} alt={`RELI step ${index + 1}: ${step.title}`} compact />
            {index < steps.length - 1 && <span className="step-arrow" aria-hidden="true">→</span>}
            <div className="step-copy">
              <span>{index + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
